module.exports = __webpack_public_path__ + "static/media/border6.ff7208f0.png";